import router from '@/router'

router.addRoute({
  path: '/hotel/sadmin/illustration',
  name: 'illustration',
  component: () => import('./View.vue')
})
